<script>
    import _ from 'lodash'
    import UiFormFromarchetype from '../../elements/ui-form-fromarchetype.vue'
    import uiInputHandler from '../../elements/ui-input-handler.vue'
    
    import {usuarioClientefacturacionArchetype} from './clientefacturacionArchetype'
    
    export default {
        name: 'UsuariosClientefacturacion',
	    components: { uiInputHandler, UiFormFromarchetype },
        
        props: {
            value: {
                type: [Number, String, Object, Array, Boolean]
            },
            source: {
                type: [Number, String, Object, Array]
            },
            estados: {
                type: Array,
                required: true
            },
            bancos: {
                type: Array,
                required: true
            }
        },
        
        data: () => {
            return {
                usuarioClientefacturacionArchetype,
                workingValue: null
            }
        },
        
        computed: {
            formArchetype(){
                let resp = []
                _.forEach(this.usuarioClientefacturacionArchetype, item => {
                    if(_.isArray(item) && item[0].key == 'idestado_fk'){
                        item[0].type = 'select';
                        item[0].options = _.clone(this.estados)
                    }
                    if(_.isArray(item) && item[0].key == 'idbanco_fk'){
                        item[0].type = 'select';
                        item[0].options = _.clone(this.bancos)
                    }
                    resp.push(item)
                })
                return resp
            }
        },
        
        watch: {
            workingValue(){
                this.$emit('input', this.workingValue)
            }
        },

        methods: {
            triggerUpdated(){
                console.log('triggerUpdated', this.workingValue)
            }
        },

        beforeMount(){
            this.workingValue = _.clone( this.value )
        }
    }
</script>

<template>
    <!-- <b-card class="card-clientefacturacion" header="Datos de facturación"> -->
        <ui-form-fromarchetype :formArchetype="formArchetype" v-model="workingValue" :source="source" @updated="triggerUpdated"/>
    <!-- </b-card> -->
</template>

<style lang="less" scoped>
    .card-clientefacturacion  {
        
    }
</style>